import { useContext, useEffect, useState } from 'react'

import { Skeleton } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { PassContext } from "/components/editor/pass-context"
import { getTemplateData } from '/providers/templates-api'

import AppleFront from "/components/editor/apple/front"
import AppleBack from "/components/editor/apple/back"

const TemplatePreview = ({ template, pass, classes }) => {

  const { apiSource, apiKeys, client } = useContext(AppContext)

  const [templateData,setTemplateData] = useState(null)
  const [instanceData,setInstanceData] = useState(null)
  const [scannerInstanceData,setScannerInstanceData] = useState(null)
  const [isSmartixScannerPass,setIsSmartixScannerPass] = useState(false)

  const templateId = pass.template_id

  const getTData = async () => {
    const td = await getTemplateData({ apiSource, apiKeys, templateId })
    if (!td.error) {
      setTemplateData(td.template)
      if (td.template.smartix_scanner) setIsSmartixScannerPass(true)
    }
  // TODO handle error
  }
  
  useEffect(() => {
    getTData()
    setInstanceData(pass.instance_data)
    setScannerInstanceData(pass.scanner_instance_data)
  },[pass])
  
  if (!pass || !template || !templateData) return (
    <div className={"flex flex-row gap-5 preview justify-evenly mt-5" + classes}>
      <Skeleton variant="rectangular" width={375} height={500}/>
      <Skeleton variant="rectangular" width={375} height={500}/>
    </div>

  )

  return (
    <div className={"flex flex-row gap-5 preview justify-evenly " + classes}>
      <div className="apple">
        <div className="wrapper"> {/* Put apple pass on a grey background with drop shadow */}
          <div className="pass" id="appleFront"> {/* id="appleFront" required for the image grab for the minature at the top of the back fields*/}
            <PassContext.Provider value={{ device: "apple", preview: true, clientId: client?.id, templateId: template.id, smartixPassType: template.pass_type_id, showEditableFields: false, model: templateData.apple_model, template: templateData.apple_template, instanceData, scannerInstanceData, passType: templateData.apple_pass_type, subType: templateData.apple_sub_type, isSmartixScannerPass }}>
              <AppleFront />
            </PassContext.Provider>
          </div>
        </div>
      </div>

      <div className="apple">
        <div className="wrapper"> {/* Put apple pass on a grey background with drop shadow */}
          <div className="pass">
            <PassContext.Provider value={{ device: "apple", preview: true, clientId: client?.id, templateId: template.id, smartixPassType: template.pass_type_id, showEditableFields: false, model: templateData.apple_model, template: templateData.apple_template, instanceData, scannerInstanceData, passType: templateData.apple_pass_type, subType: templateData.apple_sub_type }}>
              <AppleBack showStandardPassItems={false} />
            </PassContext.Provider>
          </div>
        </div>
      </div>

    </div>
  )
}

export default TemplatePreview